import React from "react";
import "../styles/maintenance.css";

export function MaintenancePage({ onRetry, isRetrying }) {
    return (
        <div className="mn-overlay">
            {/* Particle dots background */}
            <div className="mn-bg-dots" />

            {/* Animated color blobs */}
            <div className="mn-blob mn-blob-1" />
            <div className="mn-blob mn-blob-2" />

            {/* Card */}
            <div className="mn-card">

                {/* ── LOGO ── */}
                <div className="mn-logo-area">
                    <div className="mn-logo-ring mn-ring-outer" />
                    <div className="mn-logo-ring mn-ring-inner" />
                    <div className="mn-logo-core">
                        <svg viewBox="0 0 36 36" width="36" height="36" fill="none">
                            <defs>
                                <radialGradient id="coreGrad" cx="50%" cy="30%" r="70%">
                                    <stop offset="0%" stopColor="#7df9ff" />
                                    <stop offset="100%" stopColor="#0055aa" />
                                </radialGradient>
                            </defs>
                            <circle cx="18" cy="18" r="14" fill="url(#coreGrad)" opacity="0.9" />
                            <circle cx="18" cy="18" r="6" fill="rgba(0,0,0,0.5)" />
                            <circle cx="18" cy="18" r="2.5" fill="#00f2fe" />
                        </svg>
                    </div>
                    {/* Warning badge */}
                    <div className="mn-badge">!</div>
                </div>

                {/* ── BRAND ── */}
                <p className="mn-brand-name">Jamas Lens</p>
                <p className="mn-brand-tagline">Climatisation &amp; Construction</p>

                {/* ── DIVIDER ── */}
                <div className="mn-divider" />

                {/* ── TITLE ── */}
                <h1 className="mn-title">Service Indisponible</h1>

                {/* ── DESCRIPTION ── */}
                <p className="mn-desc">
                    Notre plateforme est momentanément indisponible. Nous travaillons
                    activement pour rétablir le service dans les meilleurs délais.
                </p>

                {/* ── TIPS BOX ── */}
                <div className="mn-tips">
                    <span className="mn-tips-label">Que pouvez-vous faire ?</span>
                    <ul className="mn-tips-list">
                        <li>Vérifiez votre connexion Internet.</li>
                        <li>Patientez quelques instants puis réessayez.</li>
                        <li>Contactez notre service client si le problème persiste.</li>
                    </ul>
                </div>

                {/* ── BUTTON ── */}
                <button
                    className="mn-btn"
                    onClick={onRetry}
                    disabled={isRetrying}
                >
                    {isRetrying ? (
                        <>
                            <span className="mn-spinner" />
                            Actualisation...
                        </>
                    ) : (
                        <>
                            <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
                                stroke="currentColor" strokeWidth="2.5"
                                strokeLinecap="round" strokeLinejoin="round"
                                className="mn-btn-icon">
                                <path d="M1 4v6h6" />
                                <path d="M23 20v-6h-6" />
                                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15" />
                            </svg>
                            Réessayer d'accéder au site
                        </>
                    )}
                </button>

                {/* ── CONTACT ── */}
                <p className="mn-contact">
                    Besoin d'aide ?&nbsp;
                    <a href="mailto:support@jamaslens.com">support@jamaslens.com</a>
                </p>
            </div>
        </div>
    );
}
